import _ from 'lodash'
import * as types from './mutation-types'

const state = {
  list: [
    '002-koala.svg',
    '010-panda.svg',
    '020-giraffe.svg',
    '030-gorilla.svg',
    '033-bear.svg',
    '054-fox.svg',
    '074-octopus.svg',
    '076-rabbit.svg',
    '095-ant.svg',
    '096-ladybug.svg',
    '103-snail.svg',
    '116-wolf.svg',
    '122-owl.svg',
    '128-chicken-2.svg',
    '143-cat.svg',
    '157-pig.svg',
    '161-lion.svg',
    '162-tiger.svg',
    '165-dog.svg'
  ],
  players: []
}

const getters = {
  getAvatarList (state) {
    return state.list
  },
  getPlayerAvatars (state) {
    return state.players
  }
}

const actions = {
  setRandomUniqueAvatars ({ commit, state }, players) {
    let playerNumber = 0
    if (typeof players === 'number') {
      playerNumber = players
    } else {
      playerNumber = players.length
    }
    let items = _.shuffle([].concat(state.list)).slice(0, playerNumber).map((item) => {
      return {
        name: item
      }
    })
    if (typeof players === 'object') {
      players.map((player, index) => {
        items[index].user = player.user
      })
    }
    commit(types.SET_PLAYER_AVATARS, items)
  },
  setRandomPlayerAvatar ({ commit, state }, index) {
    let diff = _.difference([].concat(state.list), state.players.map(i => i.name))
    let name = _.shuffle(diff).slice(0, 1)[0]
    commit(types.SET_PLAYER_AVATAR, { index, name })
  }
}

const mutations = {
  [types.SET_PLAYER_AVATARS] (state, players) {
    state.players = players
  },
  [types.SET_PLAYER_AVATAR] (state, { index, name }) {
    state.players[index].name = name
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/avatar.js